export { default } from "./ConfigPanel";
